import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import ActionTypes from '../../../constants/ActionTypes';
import { isEmpty as _isEmpty, forIn as _forIn, reduce as _reduce } from 'lodash';
import { utils as tileGridUtils } from '@gisatcz/ptr-tile-grid';
import helpers from './helpers';
import common from '../../_common/actions';
import Select from '../../Select';
var actionTypes = ActionTypes.DATA.SPATIAL_DATA; // ============ creators ===========

/**
 * It ensure adding index and adding received data from BE.
 * Add data to state only when spatialData received, in case of empty spatialData it adds only index.
 * @param {Object} spatialData Object received from BE contains under spatialDataKey object of data attributes [id]: {data, spatialIndex}.
 * @param {Object} filter Filler object contains modifiers and areaTreeLevelKey.
 * @param {Array?} order
 * @param {string?} changedOn
 */

var receiveIndexed = function receiveIndexed(spatialData, filter, order, changedOn) {
  return function (dispatch) {
    if (spatialData && !_isEmpty(spatialData)) {
      return dispatch(addDataAndIndex(spatialData, filter, order, changedOn));
    }
  };
};
/**
 * Add data and index at the same time
 * Add data, even if data are empty, for replacing loading indicator.
 * @param spatialDataAndIndexByDataSourceKey {Object} [dataSourceKey]: {data: Object, spatialIndex: Object}
 * @param filter {Object}
 * @param order {Array}
 * @param changedOn {string}
 */


function addDataAndIndex(spatialDataAndIndexByDataSourceKey, filter, order, changedOn) {
  return function (dispatch) {
    var spatialDataTiled = helpers.isSpatialDataTiled(spatialDataAndIndexByDataSourceKey);

    if (spatialDataTiled) {
      var indexByLevelByTileByDataSourceKey = getTiledIndexData(spatialDataAndIndexByDataSourceKey); // spatialData should be only from one level

      var level = Object.keys(indexByLevelByTileByDataSourceKey)[0];
      var spatialDataByDataSourceKey = {};

      _forIn(spatialDataAndIndexByDataSourceKey, function (value, spatialDataSourceKey) {
        spatialDataByDataSourceKey[spatialDataSourceKey] = value.data;
      });

      dispatch(actionAddDataAndTiledIndex(spatialDataByDataSourceKey, level, filter, order, [indexByLevelByTileByDataSourceKey], changedOn));
    } else {
      // Case for non tiled geometry type
      var index = getIndexData(spatialDataAndIndexByDataSourceKey);
      var _spatialDataByDataSourceKey = {};

      for (var _i = 0, _Object$entries = Object.entries(spatialDataAndIndexByDataSourceKey); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            dsKey = _Object$entries$_i[0],
            data = _Object$entries$_i[1];

        _spatialDataByDataSourceKey[dsKey] = data.data;
      } // Remove previous loading index


      dispatch(actionRemoveIndex(filter, order)); // Add new index with data

      dispatch(actionAddDataAndIndex(_spatialDataByDataSourceKey, filter, order, [index], changedOn));
    }
  };
}
/**
 * Create new index based on given level and tiles with loading indicator.
 * @param {Object} filter Filler object contains modifiers and areaTreeLevelKey.
 * @param {Array?} order
 * @param {Number} level
 * @param {Array.[Array]} tiles
 */


function addLoadingIndex(filter, order, level, tiles) {
  var changedOn = null; //create index with tiles value "true" that indicates loading state

  var loadingTiles = _reduce(tiles, function (acc, tile) {
    var tileId = tileGridUtils.tileAsString(tile);
    acc[tileId] = true;
    return acc;
  }, {});

  var index = _defineProperty({}, level, loadingTiles);

  return actionAddIndex(filter, order, [index], changedOn);
} // ============ helpers ============

/**
 * Get data for indexing for tiledVector type
 * @param spatialDataByDataSourceKey {Object} [dataSourceKey]: {data: Object, spatialIndex: Object}
 * @return {Object}
 */


function getTiledIndexData(spatialDataByDataSourceKey) {
  var indexByLevelByTileByDataSourceKey = {};

  for (var _i2 = 0, _Object$entries2 = Object.entries(spatialDataByDataSourceKey); _i2 < _Object$entries2.length; _i2++) {
    var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
        dsKey = _Object$entries2$_i[0],
        datasource = _Object$entries2$_i[1];

    for (var _i3 = 0, _Object$entries3 = Object.entries(datasource.spatialIndex); _i3 < _Object$entries3.length; _i3++) {
      var _Object$entries3$_i = _slicedToArray(_Object$entries3[_i3], 2),
          level = _Object$entries3$_i[0],
          tiles = _Object$entries3$_i[1];

      if (!indexByLevelByTileByDataSourceKey[level]) {
        indexByLevelByTileByDataSourceKey[level] = {};
      }

      for (var _i4 = 0, _Object$entries4 = Object.entries(tiles); _i4 < _Object$entries4.length; _i4++) {
        var _indexByLevelByTileBy;

        var _Object$entries4$_i = _slicedToArray(_Object$entries4[_i4], 2),
            tile = _Object$entries4$_i[0],
            tileData = _Object$entries4$_i[1];

        //Add to existing index
        if (indexByLevelByTileByDataSourceKey !== null && indexByLevelByTileByDataSourceKey !== void 0 && (_indexByLevelByTileBy = indexByLevelByTileByDataSourceKey[level]) !== null && _indexByLevelByTileBy !== void 0 && _indexByLevelByTileBy[tileGridUtils.tileAsString(tile)]) {
          indexByLevelByTileByDataSourceKey[level][tileGridUtils.tileAsString(tile)] = _objectSpread(_objectSpread({}, indexByLevelByTileByDataSourceKey[level][tileGridUtils.tileAsString(tile)]), {}, _defineProperty({}, dsKey, tileData));
        } else {
          //Create new tile and insert dsKey index data
          indexByLevelByTileByDataSourceKey[level][tileGridUtils.tileAsString(tile)] = _defineProperty({}, dsKey, tileData);
        }
      }
    }
  }

  return indexByLevelByTileByDataSourceKey;
}
/**
 * Get data for indexing for vector type
 * @param spatialDataByDataSourceKey {Object} [dataSourceKey]: {data: Object}
 * @return {Object}
 */


function getIndexData(spatialDataByDataSourceKey) {
  var indexByDataSourceKey = {};

  for (var _i5 = 0, _Object$entries5 = Object.entries(spatialDataByDataSourceKey); _i5 < _Object$entries5.length; _i5++) {
    var _Object$entries5$_i = _slicedToArray(_Object$entries5[_i5], 2),
        dsKey = _Object$entries5$_i[0],
        datasource = _Object$entries5$_i[1];

    indexByDataSourceKey[dsKey] = _toConsumableArray(Object.keys(datasource.data));
  }

  return indexByDataSourceKey;
} // ============ actions ============


function actionRemoveIndex(filter, order) {
  return {
    type: actionTypes.INDEX.REMOVE,
    filter: filter,
    order: order
  };
}

function actionAddDataAndTiledIndex(dataByDataSourceKey, level, filter, order, indexData, changedOn) {
  return {
    type: actionTypes.ADD_WITH_TILED_INDEX,
    dataByDataSourceKey: dataByDataSourceKey,
    level: level,
    filter: filter,
    order: order,
    indexData: indexData,
    changedOn: changedOn
  };
}

function actionAddDataAndIndex(dataByDataSourceKey, filter, order, indexData, changedOn) {
  return {
    type: actionTypes.ADD_WITH_INDEX,
    dataByDataSourceKey: dataByDataSourceKey,
    filter: filter,
    order: order,
    indexData: indexData,
    changedOn: changedOn
  };
}

function actionAddIndex(filter, order, index, changedOn) {
  return {
    type: actionTypes.INDEX.ADD,
    filter: filter,
    order: order,
    indexData: index,
    changedOn: changedOn
  };
}

var updateStore = common.updateStore(Select.data.spatialData.getSubstate, actionTypes); // ============ actions ============
// ============ export ===========

export default {
  addLoadingIndex: addLoadingIndex,
  getTiledIndexData: getTiledIndexData,
  getIndexData: getIndexData,
  removeIndex: actionRemoveIndex,
  receiveIndexed: receiveIndexed,
  updateStore: updateStore
};